export function loadSiteContent(vm, key, defaults) {
  return vm.$http
    .get(`DataDictionary/GetDataDictionaryAll?key=${encodeURIComponent(key)}`)
    .then(response => {
      const record = Array.isArray(response.data) ? response.data[0] : null;
      if (!record || !record.Content) return { ...defaults };
      try {
        return { ...defaults, ...JSON.parse(record.Content) };
      } catch (error) {
        window.console.warn(`Invalid site content for ${key}`, error);
        return { ...defaults };
      }
    })
    .catch(() => ({ ...defaults }));
}
